import React, { PureComponent } from 'react';
import { string } from 'prop-types';
import { withLocalStorage } from 'connectors';
import { localStorageShape } from 'shapes';
import axios from 'axios';
import Tile from './Tile/Tile';

let isMounted;

class Merchandising extends PureComponent {
    static propTypes = {
        className: string.isRequired,
        localStorage: localStorageShape.isRequired,
    };

    state = {
        tiles: [],
    };

    componentDidMount() {
        isMounted = true;
        this.props.localStorage.get().then(res => {
            if (isMounted) {
                this.setState({ tiles: res });
            }
        });
    }

    componentWillUnmount() {
        isMounted = false;
    }

    render() {
        const { className } = this.props;
        return (
            <div className={className}>
                {this.state.tiles.map(tile => (
                    <Tile
                        key={`tile-${tile.id}`}
                        image={tile.image}
                        title={tile.title}
                        url={tile.url}
                        buttonText={tile.buttonText}
                    />
                ))}
            </div>
        );
    }
}

const fetchMerchandising = () =>
    axios
        .get('/ajax/merchandizing/homepage-blocks')
        .then(({ data }) => data.items.slice(0, 3));

const onehourInMs = 60 * 60 * 1000;

export default withLocalStorage(
    'searchMerchandising',
    fetchMerchandising,
    onehourInMs,
)(Merchandising);
